import { render, staticRenderFns } from "./AppSectionHeading.vue?vue&type=template&id=3aad3644&"
import script from "./AppSectionHeading.vue?vue&type=script&lang=js&"
export * from "./AppSectionHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aad3644')) {
      api.createRecord('3aad3644', component.options)
    } else {
      api.reload('3aad3644', component.options)
    }
    module.hot.accept("./AppSectionHeading.vue?vue&type=template&id=3aad3644&", function () {
      api.rerender('3aad3644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppSectionHeading.vue"
export default component.exports